import React, { lazy } from "react";

export const EditVehicleDetailsSTAMetadata = {
  name: "Edit Vehicle Details STA",
  id: "edit_vehicle_details_sta",
  component: lazy(() => import("../VehicleManagement/EditVehicleDetailsComponent")),
  route: "/connect360/edit_vehicle_details_sta",
  Breadcrumbs: true,
};
